import { createStructuredSelector } from "reselect"
import { selectWidgetIsSubmitting } from "QuorumGrassroots/widgets/selectors"

export const petitionFormConnection = createStructuredSelector({
    isSubmitting: selectWidgetIsSubmitting,
})
